import { useEffect, useMemo } from "react";
import moment from "moment";
import PropTypes from 'prop-types';

// @mui material components
import { Box, Card, Divider, Switch, Grid } from "@mui/material";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";

import { useQuery, useMutation } from '@tanstack/react-query';

import clearwaysAPI from 'modules/clearways/api';
import groupsAPI from 'services/api/groups';
import bksAPI from 'services/api/bks';

import EventForm from "modules/clearways/components/EventForm";
import { useAuth0 } from "@auth0/auth0-react";
import { disableMap } from "utils/map";
import { wrapper, loadingScreen } from "utils/wrapper";
import { useSoftUIController } from "hooks/context";

function createEvent(data) {
    // console.log(data);
    clearwaysAPI.createClearwayEvent(data);
}

function ClearwaysEventAdd({ map, user }) {
    const [controller] = useSoftUIController();
    const { deviceLayout, selectedOrg } = controller;

    useEffect(() => {
        if (!map.current) return;
        disableMap(map, user, selectedOrg);
    }, [selectedOrg]);

    bksAPI.loadToken(useAuth0());
    groupsAPI.loadToken(useAuth0());

    var event = {
        display_time: moment().add(1, 'hour').startOf('hour').format(),
        start_time: moment().add(5, 'day').add(1, 'hour').startOf('hour').format(),
        end_time: moment().add(5, 'day').add(4, 'hour').startOf('hour').format(),
        organisation_id: "clearways",
        is_multi_day: false,
        groups: [],
        cameras_enabled: false
    };

    const groups = useQuery({
        queryKey: ['getGroups', 0, selectedOrg],
        queryFn: async () => {
            return await groupsAPI.getAllGroups();
        }
    });

    const devices = useQuery({
        queryKey: ['getAllDevices', selectedOrg],
        queryFn: async () => await bksAPI.getAllDevices(),
        refetchInterval: 300 * 1000,
        refetchIntervalInBackground: true,
    });

    const { mutate } = useMutation({
        mutationFn: (values) => createEvent(values),
    })

    if (groups.isLoading || devices.isLoading) {
        return loadingScreen(controller, true);
    }

    if (groups.error || devices.error) {
        return wrapper("Error!", controller);
    }

    if (!groups.data || !devices.data) {
        return loadingScreen(controller, false);
    }

    return wrapper((
        <Box p={1}>
            <Card>
                <EventForm event={event} groups={groups} devices={devices.data} onSubmit={mutate} isAdd={true} />
            </Card>
        </Box>
    ), controller, true
    );
}

ClearwaysEventAdd.propTypes = {
    map: PropTypes.object,
    navTitle: PropTypes.array,
    setNavTitle: PropTypes.func,
    sidebarState: PropTypes.string,
    setSidebarState: PropTypes.func,
}

export default ClearwaysEventAdd;